"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    DpErrorBoundary: {
        message: 'Oops, something went wrong, try again later or contact support',
        redirect: 'Go to home',
    },
};
